import * as React from "react";
import ObCheckbox from "../generic/obCheckbox";
import "../../../../assets/scss/components/toc/orderBook/obConvertPositions/obConvertPositionDesk.scss";
import "../../../../assets/scss/components/toc/orderBook/obConvertPositions/obConvertPositionTab.scss";
import Tooltip from "../generic/obTooltips";
import moment from "moment";
import { dateTimeFormat } from './../../../service/dateTimeService';

export interface IObTradeTabContentProps {
	isSelected?: boolean;
	onSelect?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	showCheckbox: boolean;
	tooltipTxt?: string;
	data: any;
}

const ObTradeTabContent: React.FC<IObTradeTabContentProps> = props => {
	return (
		<li className="ob_conv_row">
			<div className="left_col_con">
				{props.showCheckbox && (
					<div className="col check_box">
						<ObCheckbox checked={props.isSelected || false} name="eqTradeCheckBox" onChange={props.onSelect!} />
					</div>
				)}
				<div className="col trd_qty">{props.data.qty}qty</div>
				<div className=" col hr_row">
					<hr className="slim_line"></hr>
				</div>
				<div className="col amt">
					₹{props.data.ntPrc}
					{props.tooltipTxt && <Tooltip tooltipTxt={props.tooltipTxt} />}
				</div>
			</div>
			<div className="right_col_con">
				{!props.showCheckbox && (
					<div className="col trd_id taRight">
						Trade ID: <span>{props.data.trdID}</span>
					</div>
				)}
				<div className="type_time">
					{/* ordType for equity and ordTyp for commodity*/}
					<div className="col trd_type">{props.data.ordType?props.data.ordType :props.data.ordTyp}</div> 
					<div className="col trd_time">{moment(dateTimeFormat(props.data.rcvTim)).format("HH:mm:ss")}</div>
				</div>
			</div>
		</li>
	);
};

export default ObTradeTabContent;
